import PricingCard from './PricingCard';
import { getPricingPlans } from '../data/pricingPlans';

const PricingPlans = () => {
  const pricingPlans = getPricingPlans();

  return (
    <section>
      <div className="text-center mb-6">
        <h2 className="text-3xl font-bold text-gray-800">Choose Your Plan</h2>
        <p className="text-gray-600 mt-2">Flexible options to match your interview prep needs</p>

        <div className="flex items-center justify-center gap-3 mt-4">
          <span className="text-gray-700 font-medium">Different currency options in the next step</span>
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-8">
        {pricingPlans.map((plan, index) => (
          <PricingCard key={index} plan={plan} />
        ))}
      </div>
    </section>
  );
};

export default PricingPlans;
